import { Aurelia, autoinject, bindable, computedFrom } from 'aurelia-framework';
import { CostCenterServiceLink, LinkedMappingsService } from "./linked-mappings-service";
import { filter } from "lodash";

@autoinject
export class CostCenterLinkedServicesList {

	@bindable costCenterId: string;
	@bindable dimensionValueIds: string = "";
	@bindable serviceStructureId: string;

	@computedFrom("linkedMappingsService.costCenterServiceLinksCache", "dimensionValueIds")
	get costCenterServices(): CostCenterServiceLink[] {

		const dimensionValueIdsArray = this.dimensionValueIds ? this.dimensionValueIds.split(",") : null;
		return this.linkedMappingsService.getLinksOfTargeting(this.costCenterId, dimensionValueIdsArray);
	}

	constructor(private linkedMappingsService: LinkedMappingsService) {
	}

	removeCostCenterService(link: CostCenterServiceLink): void {
		this.linkedMappingsService.removeLinkedCostCenter(link, this.serviceStructureId);
	}

	toggleCollectMeasures(link: CostCenterServiceLink, shouldBeCollected: boolean) {
		this.linkedMappingsService.toggleCollectMeasuresForCostCenter(link, shouldBeCollected, this.serviceStructureId);
	}
}
